/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { UsageType, FindUsageTypeParams } from 'types';

const find = async (params: ?FindUsageTypeParams): Promise<UsageType[]> => {
  const { broadcastTypeId, productionTypeId } = params || {};
  const response = await callLiferayEndpoint(
    '/protones-portlet.tipologieutilizzo/find-by-tipologia-emissione-and-tipologia-produzione',
    {
      tipologiaEmissioneId: broadcastTypeId || 0,
      tipologiaProduzioneId: productionTypeId || 0,
    }
  );
  return response.map(utils.toUsageType);
};

export default {
  find,
};
